/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Yearly_DescriptionInputs */

const en_pricing_yearly_description = /** @type {(inputs: Pricing_Yearly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A full year of listening.`)
};

const es_pricing_yearly_description = /** @type {(inputs: Pricing_Yearly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un año entero de audio.`)
};

/**
* | output |
* | --- |
* | "A full year of listening." |
*
* @param {Pricing_Yearly_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_yearly_description = /** @type {((inputs?: Pricing_Yearly_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Yearly_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_yearly_description(inputs)
	return en_pricing_yearly_description(inputs)
});